<div tabindex="0" class="toast" title="Benachrichtigung schliessen" [style.display]="state.value === 'inactive' ? 'none' : ''">
  <div class="col-9">
    <div *ngIf="title" role="alert" aria-live="polite"
         [class]="options.titleClass" [attr.aria-label]="title">{{ title }}</div>
    <div *ngIf="message" role="alert" aria-live="polite"
         [class]="options.messageClass" [attr.aria-label]="message">{{ message }}</div>
  </div>
</div>
